import { BrainCircuit, GitBranch, RefreshCcw } from "lucide-react";
import { Reveal, SectionHeading } from "../components/site/Reveal";
import { MagneticButton } from "../components/site/MagneticButton";
import { useCalendly } from "../components/site/CalendlyModal";

const PILLARS = [
  { icon: BrainCircuit, title: "Inteligencia", text: "La tecnología entiende. Diseñamos sistemas que aprenden del negocio y potencian a las personas." },
  { icon: GitBranch, title: "Conexión", text: "Los sistemas trabajan juntos. Integramos aplicaciones, datos y procesos en una sola operación." },
  { icon: RefreshCcw, title: "Transformación", text: "El negocio evoluciona. Convertimos tecnología en resultados medibles y sostenibles." },
];

export default function NosotrosPage() {
  const { openCalendly } = useCalendly();
  return (
    <div data-testid="nosotros-page">
      <section className="pt-44 pb-24 grain relative overflow-hidden">
        <div className="absolute -top-32 left-1/3 w-[520px] h-[420px] rounded-full bg-[var(--green)]/8 blur-[150px]" aria-hidden="true" />
        <div className="relative mx-auto max-w-7xl px-6">
          <SectionHeading
            eyebrow="Nosotros"
            title={<>No solo implementamos tecnología. <span className="text-gradient">Diseñamos la que resuelve.</span></>}
            copy="Netsys Panamá es una empresa de tecnología empresarial integral. Analizamos tus procesos, diseñamos la arquitectura adecuada y conectamos tecnología con resultados de negocio."
            testId="nosotros-heading"
          />
        </div>
      </section>
      <section className="pb-28">
        <div className="mx-auto max-w-7xl px-6 grid gap-5 md:grid-cols-3">
          {PILLARS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.12}>
              <div className="h-full rounded-2xl border border-[var(--line)] bg-[var(--surface)]/60 p-8 transition-colors hover:border-[var(--green)]/40" data-testid={`pillar-${p.title.toLowerCase()}`}>
                <p.icon size={26} className="text-[var(--green)]" />
                <h2 className="mt-6 text-2xl font-bold tracking-tight">{p.title}</h2>
                <p className="mt-3 text-sm leading-relaxed text-[var(--muted)]">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <div className="mx-auto max-w-7xl px-6 mt-20 text-center">
            <p className="text-2xl md:text-3xl font-bold tracking-tight mb-8">Tecnología avanzada, <span className="text-gradient">sin complejidad innecesaria.</span></p>
            <MagneticButton onClick={openCalendly} testId="nosotros-cta">Conocer nuestra metodología</MagneticButton>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
